export const deleteAttachmentOwnerWarning =
    'th.inbox.conversation.attachment.owner.body';
export const deleteAttachmentIPMWarning =
    'th.inbox.conversation.attachment.propertyManager.body';
